import React, { useMemo, useState } from 'react';
import { BuroCombobox } from './BuroCombobox';
import { ACTIVIDADES, SIN_DATO_COMERCIAL, SIN_DATO_FINANCIERA, describirActividad } from './catalogoActividad';

const OTRO = '__otro__';

// Los "sin dato" se buscan como cualquier actividad; "Otro" queda siempre al final como salida.
const OPCIONES = [
  { value: SIN_DATO_FINANCIERA, label: `${SIN_DATO_FINANCIERA} · Sin dato (entidad financiera)` },
  { value: SIN_DATO_COMERCIAL, label: `${SIN_DATO_COMERCIAL} · Sin dato (empresa comercial)` },
  ...ACTIVIDADES.map(([codigo, nombre]) => ({ value: codigo, label: `${codigo} · ${nombre}` })),
];
const FIJAS = [{ value: OTRO, label: 'Otro (escribir el código)…' }];

/*
 * Selector de actividad económica (EM10/EM11/EM12 de PM/PFAE).
 * Muestra qué actividad es el código capturado y deja buscar en el catálogo SCIAN escribiendo
 * (por texto o por código) en el mismo campo, con la lista abierta debajo. "Otro" es para códigos
 * que no están (p. ej. una clave Banxico de 7 dígitos), que se escriben en el campo de arriba.
 *
 * props:
 *   value     código actual (el mismo que edita el campo de arriba)
 *   onChange  recibe el código elegido
 *   disabled  bloquea mientras viaja el guardado
 */
export const BuroActividadSelect = ({ value, onChange, disabled }) => {
  const [otro, setOtro] = useState(false);
  const actual = String(value ?? '').trim();
  const descripcion = describirActividad(actual);
  const fijas = useMemo(() => FIJAS, []);

  const elegir = (v) => {
    if (v === OTRO) { setOtro(true); return; }
    setOtro(false);
    onChange(v);
  };

  return (
    <div className="bu-field" style={{ gap: 6, marginTop: 8 }}>
      <div className="bu-sub" style={{ fontSize: 12 }}>
        {actual === ''
          ? 'Sin actividad capturada.'
          : descripcion
            ? <>Actividad: <strong>{descripcion}</strong></>
            : 'Este código no está en el catálogo SCIAN (puede ser una clave Banxico de 7 dígitos).'}
      </div>
      <BuroCombobox
        ariaLabel="Buscar actividad"
        placeholder="Escribe para buscar actividad (texto o código)…"
        options={OPCIONES}
        fijas={fijas}
        value=""
        onChange={elegir}
        disabled={disabled}
      />
      {otro && (
        <div className="bu-note bu-note-info" style={{ fontSize: 12 }}>
          <i className="pi pi-info-circle" />
          <span>Escribe el código en el campo «Valor para Buró» de arriba (hasta 11 dígitos). EM10, EM11 y EM12 deben ser del mismo tipo: todos SCIAN o todos Banxico.</span>
        </div>
      )}
    </div>
  );
};
